<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">臣邦医药后台管理系统</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        欢迎您，{{ username }} （工号：{{ adminCode }}）
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="setPassword">修改密码</el-dropdown-item>
                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            v-dialogDrag
            title="修改密码"
            :visible.sync="dialogFormVisible"
            width="500px"
            :modal="false"
            :append-to-body="true"
            :before-close="beforeClose"
        >
            <el-form ref="ruleForm" :model="ruleForm" label-width="80px" :rules="rules">
                <el-form-item label="旧密码" prop="old_password">
                    <el-input v-model="ruleForm.old_password" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass_word">
                    <el-input v-model="ruleForm.pass_word" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="again_password">
                    <el-input v-model="ruleForm.again_password" placeholder="请输入确认密码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancle">取 消</el-button>
                <el-button type="primary" @click="onData('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            name: '',
            dialogFormVisible: false,
            ruleForm: {
                old_password: '',
                pass_word: '',
                again_password: ''
            },
            rules: {
                old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
                pass_word: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                again_password: [{ required: true, message: '请输入确认密码', trigger: 'blur' }]
            },
            adminCode: ''
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem('adminName');
            return username ? username : this.name;
        }
    },
    created() {
        this.adminCode = localStorage.getItem('adminCode');
    },
    methods: {
        beforeClose() {
            this.dialogFormVisible = false;
            this.ruleForm = {
                old_password: '',
                pass_word: '',
                again_password: ''
            };
        },
        onData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updatePassword();
                } else {
                    return false;
                }
            });
        },
        cancle() {
            this.dialogFormVisible = false;
            this.again_password = '';
            this.old_password = '';
            this.new_password = '';
        },
        updatePassword() {
            let params = {
                old_password: this.ruleForm.old_password,
                new_password: this.ruleForm.pass_word,
                again_password: this.ruleForm.again_password
            };
            this.$api
                .updatePassword(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.ruleForm = {
                            old_password: '',
                            pass_word: '',
                            again_password: ''
                        };
                    }
                    this.dialogFormVisible = false;
                })
                .catch((error) => {
                    
                });
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                this.$msgbox
                    .confirm('确认退出系统吗?', '提示', {
                        type: 'warning'
                    })
                    .then(() => {
                        let admintoken = localStorage.getItem('adminToken');
                        let params = {
                            token: admintoken
                        };
                        this.$api
                            .logout(params)
                            .then((res) => {
                                if (res.code == 0) {
                                    localStorage.removeItem('adminToken');
                                    localStorage.removeItem('adminMenus');
                                    localStorage.removeItem('adminRoutes');
                                    localStorage.removeItem('adminName');
                                    localStorage.removeItem('dataList');
                                    localStorage.removeItem('adminCode');
                                    this.$message({
                                        message: '退出成功！',
                                        type: 'success'
                                    });
                                    this.$router.push({ path: '/login' });
                                }
                            })
                            .catch((error) => {
                                
                            });
                    })
                    .catch(() => {
                    });
            } else if (command == 'setPassword') {
                this.dialogFormVisible = true;
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            this.$bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    font-size: 17px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 50px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 50px;
    font-size: 17px;
}
.header-right {
    float: right;
    padding-right: 30px;
}
.header-user-con {
    display: flex;
    height: 50px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
.dialog_input {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
}
.pass_word {
    width: 100%;
    height: 50px;
    display: flex;
    line-height: 50px;
}
.pass_word span {
    width: 100px;
    height: 50px;
    display: inline-block;
    text-align: right;
    padding-right: 15px;
}
</style>
